"use strict";

exports.__esModule = true;
var _PlantStateActivitiesScreen = require("./PlantStateActivitiesScreen");
Object.keys(_PlantStateActivitiesScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantStateActivitiesScreen[key]) return;
  exports[key] = _PlantStateActivitiesScreen[key];
});